import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from "reactstrap"
import FilterSku from "./filters/FilterSku"
import FilterName from "./filters/FilterName"
import FilterStatus from "./filters/FilterStatus"
import FilterProcedure from "./filters/FilterProcedure"
import FilterPartner from "./filters/FilterPartner"
import FilterMex from './filters/FilterMex'
import { Label } from 'reactstrap'
import { Select } from 'antd'

class SkuFilters extends Component {
    render() {
        const { filters, onChangeFilter, onChangeFilterName, listPartner, onChangeFilters, listProductionProcess } = this.props

         const partnerOptions = listPartner.filter(i => i.name === "MC Lab").map(i=>({
            label: i.name,
            value: i._id,
        }))

        const processOptions = listProductionProcess.map(i => ({ label: i.name, value: i._id }))
        const commitmentTimeFastProduction = [
            { label: 'All', value: 'all' },
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
        ]

        return (
            <div className="SkuFilters pt-3 pl-3 pr-3 mb-3">
                <Row form>
                    <Col md={2} style={{ minWidth: '287px' }}>
                        <FilterName name={filters.name} onChangeFilter={onChangeFilterName} />
                    </Col>
                    <Col md={3} style={{ minWidth: '424px' }}>
                        <FilterSku sku={filters.sku} onChangeFilter={onChangeFilter} onChangeFilters={onChangeFilters} filters={filters} />
                    </Col>
                    <Col md={1} style={{ minWidth: '120px' }}>
                        <FilterStatus status={filters.is_active} onChangeFilter={onChangeFilter} />
                    </Col>
                    <Col md={1} style={{minWidth:'120px'}}>
                        <FilterProcedure procedure={filters.procedure} onChangeFilter={onChangeFilter}/>
                    </Col>
                    <Col md={1} style={{ minWidth: '120px' }}>
                        <FilterMex procedure={filters.partner} onChangeFilter={onChangeFilter} selectOptions={partnerOptions} />
                    </Col>
                    <Col md={1} style={{ minWidth: '210px' }}>
                        <FilterPartner partner={filters.partner} onChangeFilter={onChangeFilter} selectOptions={partnerOptions} />
                    </Col>
                    <Col md={2} style={{ minWidth: '120px' }}>
                        <div className="FilterProcess">
                            <div className="Select">
                                <Label style={{ whiteSpace: "nowrap" }}>Quy trình sản xuất</Label>
                                <Select
                                    options={processOptions}
                                    style={{ minWidth: '250px' }}
                                    placeholder='Chọn quy trình sản xuất'
                                    showSearch
                                    value={filters.production_process || []}
                                    onChange={(value)=>onChangeFilter('production_process', value)}
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="FilterProcess">
                            <div className="Select form-group">
                                <Label style={{ whiteSpace: "nowrap" }}>Thời gian sản xuất nhanh</Label>
                                <Select
                                    options={commitmentTimeFastProduction}
                                    style={{ minWidth: '250px' }}
                                    placeholder='Thời gian sản xuất nhanh'
                                    showSearch
                                    value={filters.has_commitment_time_fast_production || []}
                                    onChange={(value)=>onChangeFilter('has_commitment_time_fast_production', value)}
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

SkuFilters.propTypes = {
    filters: PropTypes.object,
    onChangeFilter: PropTypes.func,
    onChangeFilterName: PropTypes.func
}

export default SkuFilters